<!-- use tags -->

import Layout1 from "../../src/routes/guide-examples/+layout.marko";
import Page from "../../src/routes/guide-examples/skeleton-examples/out-of-order/example-4/+page.marko";

<Layout1>
	<Page/>
</>
